import React from 'react'
import { Tabs, Collapse, List, Typography } from 'antd'

const { TabPane } = Tabs
const { Panel } = Collapse
const { Text } = Typography


// Ganti tag khusus jadi HTML valid
const renderHTML = (text, bankAccount) => {
    console.log(bankAccount)
    return text
        .replace(/<bold>(.*?)<\/bold>/g, '<strong>$1</strong>')
        .replace(/<anchor>(.*?)<\/anchor>/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
        .replace(/{{fullPaymentCode}}/g, bankAccount?.availBank?.bankAccountNumber) // placeholder VA
    // .replace(/{{iBankingSource}}/g, 'https://ibank.permatabank.com') // placeholder URL
}

const PaymentSteps = ({ paymentData, bankAccount }) => {
    return (
        <Tabs defaultActiveKey="atm" type="card">
            {Object.entries(paymentData).filter(item => {
                const type_bank = item[0]
                return type_bank !== "ibanking"
            }).map(([channel, sections]) => (
                <TabPane tab={channel.toUpperCase()} key={channel}>
                    <Collapse accordion>
                        {sections.map((section, idx) => (
                            <Panel header={section.title} key={idx}>
                                <List
                                    size="small"
                                    bordered
                                    dataSource={Object.entries(section.steps)}
                                    renderItem={([en, id]) => (
                                        <List.Item>
                                            <div>
                                                {/* <Text strong>{en}</Text>
                                                <br /> */}
                                                <span
                                                    dangerouslySetInnerHTML={{ __html: renderHTML(id, bankAccount) }}
                                                />
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            </Panel>
                        ))}
                    </Collapse>
                </TabPane>
            ))}
        </Tabs>
    )
}

export default PaymentSteps
